module.exports = __webpack_public_path__ + "files/038443c836a27b08210f598c5ed02d89.png";